export default function ({ $axios, error: nuxtError }) {
  // const api = $axios.create()

  // // Set baseURL to something different
  // api.setBaseURL(process.env.NUXT_ENV_SOURCE_URL)

  // // Inject to context as $api
  // inject('api', api)
  $axios.onRequest((config) => {
    // config.withCredentials = true
    if (config.url.includes('/null/')) {
      console.info('axios error in request url')
    }
    if (config.url.includes('/api/')) {
      config.baseURL = ''
    }
    return config
  })

  // $axios.setHeader('Cache-Control', 'no-cache', ['get'])
  // $axios.setHeader('Pragma', 'no-cache', ['get'])
  // $axios.setHeader('Expires', '0', ['get'])
  // axiosInstance.defaults.headers = {
  //   'Cache-Control': 'no-cache',
  //   'Pragma': 'no-cache',
  //   'Expires': '0',
  // };
  $axios.onError((error) => {
    console.error(error)
    console.info('axios error - onError')
    console.error(error.config.url)
    // nuxtError({
    //   statusCode: error.status,
    //   message: error.message
    // })
    return Promise.resolve(false)
  })
  $axios.onRequestError((error) => {
    console.info('axios error - onRequestError')
    nuxtError({
      statusCode: error.status,
      message: error.message
    })
    return Promise.resolve(false)
  })
  $axios.onResponseError((error) => {
    console.info('axios error - onResponseError')
    nuxtError({
      statusCode: error.status,
      message: error.message
    })
    return Promise.resolve(false)
  })
}
